import { render, staticRenderFns } from "./CarSegment.vue?vue&type=template&id=d4db852a&"
import script from "./CarSegment.vue?vue&type=script&lang=js&"
export * from "./CarSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports